export const parkingPaymentInfo = {
  lotName: "极氪中心 B2 停车场",
  plateNumber: "浙A·E8296",
  spaceLabel: "B2-153",
  entryTime: "16:42",
  payTime: "18:58",
  duration: "2小时16分钟",
  amountYuan: "18.00",
  serviceFeeYuan: "0.00",
  orderNo: "P202606061858",
  merchant: "支付宝停车服务"
};

export function parkingAmountLabel() {
  return `${Number(parkingPaymentInfo.amountYuan)}元`;
}
